module.exports = __webpack_public_path__ + "img/mb-step-4.d526ce32.png";